import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Feedback can have an impact regardless of whether it is positive
                                                or negative – the aim is to make
                                                it constructive and meaningful. There are many factors besides
                                                feedback that you can use
                                                to successfully develop others and help them to succeed at
                                                varying levels. This tool is about
                                                <span
                                                    className="brown brownbold">how to develop others</span> and
                                                will help you to increase your awareness of the key steps
                                                necessary
                                                to develop others, the potential resources to use, and different
                                                formats that can be used for
                                                development planning.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">INTRODUCTION TO DEVELOPING OTHERS</span>
                                            </div>
                                            <p>What do you think it’s all about, this business of managing other
                                                people? Not so long ago, the
                                                stereotypical manager was a slightly removed figure, but ‘in
                                                charge’ – clocking us in and out. It
                                                was a matter of ensuring achievement of specific functions and
                                                processes, by those assigned to
                                                carry them out. And still, this must be a manager’s fundamental
                                                purpose.</p>
                                            <p>But there’s a whole lot more to it now. Not only do businesses
                                                need to constantly adapt and change
                                                to keep pace with technological advances and changing working
                                                methods, they also need to keep
                                                up with the need to develop employees’ skills in tandem.
                                                However, employee development is not
                                                only about what will benefit an enterprise. Employees themselves
                                                expect it and will often walk if it’s
                                                not made available because, according to research, it motivates
                                                people as much if not more than
                                                money. Without opportunities to grow, people leave their jobs.
                                                And they blame their managers.</p>

                                            <div className="border_subtitle ">Developing others is therefore one
                                                of the most crucial elements of your role
                                                as a manager.
                                            </div>
                                            <p>Unfortunately, the responsibility of developing other people is
                                                often thrust upon managers who,
                                                while extremely competent in their technical areas of expertise,
                                                are less skilled in knowing how
                                                to help others develop. These people can be labelled ‘bad
                                                bosses’ and are often pointed to as the
                                                reason for individuals leaving their organisation, with the most
                                                common specific reason being
                                                their ‘bad boss’ did not provide opportunity for career growth
                                                and development.<a className="superscripttext "
                                                                   href="further_info.php?course=300"><sup>3</sup></a>
                                            </p>


                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <p>‘People don’t leave jobs, they just leave bad bosses’</p>


                                            </div>

                                            <p>This tool provides straightforward insight into the key steps
                                                required for managers to effectively
                                                develop their employees. It also provides hints and tips for
                                                managers on key aspects of the process.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}